import React, { useState, forwardRef } from "react";

const AchievementSection = forwardRef((props, ref) => {
    return (
    <section ref={ref} className="py-10 bg-gradient-to-br from-yellow-200 via-yellow-300 to-yellow-100 sm:py-16 lg:py-24">
            <div className="max-w-5xl px-4 mx-auto sm:px-6 lg:px-8">
                <div className="max-w-2xl mx-auto text-center">
                    <h2 className="text-4xl md:text-6xl font-bold mb-8 font-bold text-center mb-12 text-black">Our story</h2>
                </div>

                <div className="grid grid-cols-1 gap-8 mt-10 text-center lg:mt-24 sm:gap-x-8 md:grid-cols-3">
                    <div className="bg-white shadow-lg rounded-xl p-6 transition-transform transform hover:scale-105">
                        <h3 className="font-bold text-7xl text-black">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-blue-600">7+</span>
                        </h3>
                        <p className="mt-4 text-xl font-medium text-black">Years in business</p>
                        <p className="text-base mt-0.5 text-black">Creating the successful path</p>
                    </div>

                    <div className="bg-white shadow-lg rounded-xl p-6 transition-transform transform hover:scale-105">
                        <h3 className="font-bold text-7xl text-black">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-blue-600">205+</span>
                        </h3>
                        <p className="mt-4 text-xl font-medium text-black">Projects delivered</p>
                        <p className="text-base mt-0.5 text-black">In last 7 years</p>
                    </div>

                    <div className="bg-white shadow-lg rounded-xl p-6 transition-transform transform hover:scale-105">
                        <h3 className="font-bold text-7xl text-black">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-600 to-blue-600">100+</span>
                        </h3>
                        <p className="mt-4 text-xl font-medium text-black">Happy Customers</p>
                        <p className="text-base mt-0.5 text-black">Working for your success</p>
                    </div>
                </div>
            </div>
        </section>
    );
})

export default AchievementSection;
